import { Auth } from 'aws-amplify';

export const validateAdminUser = (data: any) => {
  const payload = data.signInUserSession?.accessToken?.payload || {};
  const groups = payload['cognito:groups'] ? payload['cognito:groups'] : [];

  if (!groups.includes(`trac-${process.env.REACT_APP_STAGE}-admin`)) {
    throw new Error('Unauthorized');
  }
}

export const isLoggedIn = async (): Promise<boolean> => {
  try {
    const user = await Auth.currentAuthenticatedUser()
    validateAdminUser(user);
  } catch {
    return false;
  }

  return true;
}

export const getUser = async (): Promise<any | void> => {
  try {
    return await Auth.currentAuthenticatedUser();
  } catch(e) {
    // unauthenticated
  }
}

export const getToken = async (): Promise<string | void> => {
  const user = await getUser();

  if (user) {
    return user.signInUserSession.idToken.jwtToken;
  }
}